import { Box, Counter, QuickFilter, QuickFilterGroup, Text } from '@razorpay/blade/components';
import { earningFiltersMap, statusFilters } from 'components/SalaryComponents/constants';
import { useFilters } from 'hooks/useFilters';
import React from 'react';

export type StatusFilterKeyType = keyof typeof statusFilters;
export type StatusFilterColorType = 'positive' | 'notice' | 'information';
export type StatusFilterColorsType = Record<StatusFilterKeyType, StatusFilterColorType>;

const StatusFilter = ({ counts }: { counts?: Record<StatusFilterKeyType, number> }) => {
  const { currentFilters, applyFilter } = useFilters({
    filtersMap: { status: earningFiltersMap.status },
  });

  const statusFilterColors: StatusFilterColorsType = {
    active: 'positive',
    disabled: 'notice',
    all: 'information',
  };

  return (
    <QuickFilterGroup
      onChange={(e) => applyFilter(earningFiltersMap.status, e.values[0])}
      defaultValue="all"
      selectionType="single"
      value={currentFilters.status}>
      <Box display="flex" gap="spacing.4" alignItems="center">
        <Text color="surface.text.gray.muted" weight="semibold">
          Filters :
        </Text>

        {Object.entries(statusFilters).map(([filterKey, filterLabel]) => {
          return (
            <QuickFilter
              key={filterKey}
              value={filterKey}
              title={filterLabel}
              trailing={
                counts && (
                  <Counter
                    value={counts?.[filterKey as StatusFilterKeyType]}
                    color={statusFilterColors[filterKey as StatusFilterKeyType]}
                  />
                )
              }
            />
          );
        })}
      </Box>
    </QuickFilterGroup>
  );
};

export default StatusFilter;
